import { render } from "./IdentiteCoureur.vue?vue&type=template&id=4f20ed56&scoped=true"
import script from "./IdentiteCoureur.vue?vue&type=script&lang=js"
export * from "./IdentiteCoureur.vue?vue&type=script&lang=js"

import "./IdentiteCoureur.vue?vue&type=style&index=0&id=4f20ed56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f20ed56"]])

export default __exports__